import type { ApiResponse, BulkInvitationItemResponse } from '@fluenceur/types';
import { useQuery } from '@tanstack/react-query';
import api from '@/libs/axiosInstance';

/** Cache key for one batch's per-recipient outcomes. */
export const bulkInvitationItemsQueryKey = (batchId: string | null) =>
  ['bulk-invitation-items', batchId] as const;

const fetchBulkInvitationItems = async (batchId: string): Promise<BulkInvitationItemResponse[]> => {
  const { data } = await api.get<ApiResponse<BulkInvitationItemResponse[]>>(
    `/dashboard/wishlist/bulk-invite/${batchId}/items`
  );
  return data.data ?? [];
};

/**
 * Per-recipient outcomes of one bulk invitation batch, feeding the epilogue
 * recap. Only fires once the send returns a batch id AND the caller enables it
 * (the recap fetches on completion, not while the batch is still processing).
 */
export const useBulkInvitationItemsQuery = (
  batchId: string | null,
  options?: { enabled?: boolean }
) =>
  useQuery({
    queryKey: bulkInvitationItemsQueryKey(batchId),
    queryFn: () => fetchBulkInvitationItems(batchId as string),
    enabled: !!batchId && (options?.enabled ?? true),
  });
